import script from "./DrillDownTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DrillDownTable.vue?vue&type=script&setup=true&lang=js"

import "./DrillDownTable.vue?vue&type=style&index=0&id=4929687b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4929687b"]])

export default __exports__